import { useState, createContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import './style.css';
import API from '../../utils/API';
import Swal from "sweetalert2";

export const AppContext = createContext();

export const ContextProvider = (props) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [auth, setAuth] = useState();
    const [user, setUser] = useState(null);
    const [userInfo, setUserInfo] = useState(null)
    const [login, setLogin] = useState(localStorage.getItem('token') && localStorage.getItem('user'));

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('yc_usr_dt_ls')))
    }, [])


    const logout = () => {
        localStorage.removeItem('yc_usr_dt_ls');
        localStorage.removeItem('token');
        setUser(null)
    }

    const logIn = (user, token) => {
        setUser(user)
        localStorage.setItem('token', token);
        localStorage.setItem('yc_usr_dt_ls', JSON.stringify(user))
    }


    return (
        <AppContext.Provider value={
            {
                getUser: user,
                getUserInfo: userInfo,
                getAuth: auth,
                logIn: (user,token) => logIn(user,token),
                logout: logout,
            }
        }>
            {props && props.children}
        </AppContext.Provider>
    )
}

export default ContextProvider;